var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "668.4835 442.0185 1830.7997 1205.026",
    width: "1830.8px",
    height: "1205.026px",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    x: 3.051,
    y: 3.205,
    width: 1830.419,
    height: 1205.026,
    style: {
      fill: "none",
      strokeWidth: 2
    },
    transform: "matrix(1, 0, -0.00031599999056197703, 1, 665.8142700195312, 438.81353759765625)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g8",
    transform: "matrix(1.0063530206680298, 0, 0, -1.0063530206680298, 458.45886230468744, 3599.948974609375)",
    style: {}
  }, /*#__PURE__*/React.createElement("g", {
    id: "g10",
    transform: "scale(0.1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 10799.4,26938.8 c -436.7,-1028.5 -105.2,-3012.4 5.8,-3012.4 -628.8,-82.1 -1226.99,-219.4 -1799.87,-402.2 -645.08,1299.6 -658.84,2613.5 1.6,3807.6 571.82,-182.4 1175.97,-300.2 1792.47,-393 z",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 36.34,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 14400.7,26784.8 c 1.9,56.7 28.4,76.1 114.2,88.8 397.3,58.9 822.1,90.4 1249.3,119.5 100.2,19.2 179.4,-34.9 249.8,-119.5 187.3,-436.5 302.3,-953.5 302.7,-1493.4 0.3,-469.3 -86,-955.8 -286.7,-1422 -32.3,-75 -133.1,-99.3 -272,-95.6 -469.5,12.3 -778.1,35.2 -1206.5,84.1 -78.1,8.9 -146.4,86.6 -138.2,167.5 90.3,879.7 100.2,1661.1 -12.6,2670.6 z",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 36.34,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 10185,28236 c 0,52.2 -56,80.9 -108.2,80.9 l -175.32,13.6 c -52.16,0 -108.18,-40.6 -108.18,-92.8 l -5.89,-242.8 c 0,-52.2 22.8,-81.5 74.96,-81.5 l 228.13,19.5 c 52.2,0 94.5,42.4 94.5,94.5 z",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 36.34,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 12257.8,27437.5 -104.3,730.1",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 36.34,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 9292.02,28317.5 c 1646.58,-119.7 3378.98,-182.3 5234.18,-163",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 36.34,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 7364.79,30434.1 c 328.16,0 594.58,-269.7 594.58,-601.8 0,-332.2 -266.42,-601.8 -594.58,-601.8 -328.15,0 -594.57,269.6 -594.57,601.8 0,332.1 266.42,601.8 594.57,601.8 z",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 36.34,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 7364.79,30693.3 c 469.54,0 850.74,-385.8 850.74,-861 0,-475.2 -381.2,-861.1 -850.74,-861.1 -469.53,0 -850.74,385.9 -850.74,861.1 0,475.2 381.21,861 850.74,861 z",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 36.34,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 14673.5,30482.1 c 328.1,0 594.5,-269.7 594.5,-601.8 0,-332.2 -266.4,-601.8 -594.5,-601.8 -328.2,0 -594.6,269.6 -594.6,601.8 0,332.1 266.4,601.8 594.6,601.8 z",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 36.34,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 14673.5,30741.3 c 469.5,0 850.7,-385.8 850.7,-861 0,-475.2 -381.2,-861.1 -850.7,-861.1 -469.6,0 -850.8,385.9 -850.8,861.1 0,475.2 381.2,861 850.8,861 z",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 36.34,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 8358.84,30179.7 5304.26,57 c 0,0 -118.8,-1276.7 1035.3,-1276.8 1082.5,-0.1 1001.6,1228 1001.6,1228 l 331.4,2.5 c 94.7,-7.4 141.4,-43.7 198.7,-54.9 54,-10.6 92.8,-10.1 138,-21 89.7,-21.4 255.8,-90.8 400,-107.7 173.8,-20.4 643,-14.5 643,-14.5 80.8,-3 127,-59.4 173.2,-115.9 51.6,-63 87.6,-158.8 101.4,-247.9 15.9,-102.9 -5.8,-369.5 -5.8,-369.5 -1.8,-76.5 -71.6,-118.9 -187.4,-138.5 l 5.7,-57.2 c -77,-100.9 -116.1,-272.8 -136,-480.6 l 65.2,-32.6 24.4,-244.4 -1295.5,-277 c -787.2,-293.5 -1737.3,-635.8 -2573.3,-741.9 -983.6,-124.8 -2168.8,-155.6 -2950.9,57.5 -624.1,170 -1816.98,888.1 -1816.98,888.1 l -277.03,-24.5 c -556.72,40.4 -1099.36,109 -1625.96,209.6 -534.43,102.2 -1052.34,237.4 -1551.68,409.7 l -81.48,114 -97.78,342.2 65.19,24.5 -122.22,138.5 97.77,505.2 c -150.19,-0.1 -97.54,103.8 52.71,109.2 l 239.14,-6.3 873.29,133.4 c 0,0 -10.71,-152.6 -3.76,-377 9.82,-316.7 305.66,-955.9 997.97,-915.5 799.58,46.6 955.02,614.2 974.82,952.3 10.82,184.9 2.74,332 2.74,332 z",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 36.34,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 9252.91,29986.2 4275.99,-32.6 c 31.5,-487 281.3,-914.5 886.5,-1245 572.1,-312.5 134.9,-532.5 0,-690.9 -283.8,-333.3 -1697.6,-696.4 -2797.7,-595.5 -911.4,83.7 -1970.31,468.3 -2364.79,895.3 -227.18,245.9 -214.75,935.1 0,1668.7 z",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 36.34,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 11951.6,29965.6 c -0.1,-6.1 -176.8,-663.8 -142.6,-1107.4 35.5,-460.8 207.7,-677.6 207.7,-677.6",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 36.34,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path34"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 11474.5,28734.6 c 161.8,-6.1 310.3,-55.7 307.3,-134.7 -3,-79.1 -136.7,-105.8 -298.5,-99.8 -161.8,6.1 -310.3,55.6 -307.3,134.7 3,79.1 136.7,105.8 298.5,99.8 z",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 36.34,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 13834.1,28688.9 c 161.8,-6 310.3,-55.6 307.3,-134.7 -3,-79.1 -136.7,-105.8 -298.5,-99.7 -161.8,6 -310.2,55.6 -307.3,134.7 3,79.1 136.7,105.8 298.5,99.7 z",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 36.34,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 11840.7,28180.6 241.1,-743.1",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 36.34,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 10188.6,22588 c 0,-52.2 -56,-80.9 -108.2,-80.9 l -175.35,-13.7 c -52.16,0 -108.18,40.7 -108.18,92.9 l -5.88,242.8 c 0,52.2 22.79,81.5 74.95,81.5 l 228.16,-19.5 c 52.2,0 94.5,-42.4 94.5,-94.6 z",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 36.34,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 12261.4,23386.4 -104.3,-730",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 36.34,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 9295.6,22506.5 c 1646.6,119.7 3379,182.3 5234.2,162.9",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 36.34,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 7368.37,20389.9 c 328.15,0 594.57,269.7 594.57,601.8 0,332.1 -266.42,601.8 -594.57,601.8 -328.16,0 -594.58,-269.7 -594.58,-601.8 0,-332.1 266.42,-601.8 594.58,-601.8 z",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 36.34,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 7368.37,20130.7 c 469.53,0 850.74,385.8 850.74,861 0,475.2 -381.21,861.1 -850.74,861.1 -469.54,0 -850.74,-385.9 -850.74,-861.1 0,-475.2 381.2,-861 850.74,-861 z",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 36.34,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 14677,20341.9 c 328.2,0 594.6,269.7 594.6,601.8 0,332.1 -266.4,601.8 -594.6,601.8 -328.1,0 -594.5,-269.7 -594.5,-601.8 0,-332.1 266.4,-601.8 594.5,-601.8 z",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 36.34,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 14677,20082.7 c 469.6,0 850.8,385.8 850.8,861 0,475.2 -381.2,861.1 -850.8,861.1 -469.5,0 -850.7,-385.9 -850.7,-861.1 0,-475.2 381.2,-861 850.7,-861 z",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 36.34,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 8362.42,20644.3 5304.18,-57.1 c 0,0 -118.7,1276.8 1035.4,1276.9 1082.4,0.1 1001.6,-1228 1001.6,-1228 l 331.4,-2.5 c 94.7,7.4 141.3,43.7 198.7,54.9 54,10.6 92.7,10.1 138,21 89.7,21.4 255.8,90.8 400,107.7 173.8,20.4 642.9,14.5 642.9,14.5 80.9,3 127.1,59.4 173.2,115.8 51.6,63.1 87.7,158.8 101.5,248 15.9,102.9 -5.8,369.5 -5.8,369.5 -1.8,76.5 -71.6,118.9 -187.4,138.5 l 5.6,57.2 c -76.9,100.9 -116,272.8 -135.9,480.6 l 65.1,32.5 24.5,244.5 -1295.5,277 c -787.2,293.5 -1737.3,635.8 -2573.3,741.9 -983.7,124.8 -2168.8,155.6 -2950.9,-57.5 -624.2,-170 -1817.01,-888.1 -1817.01,-888.1 l -277.02,24.5 c -556.72,-40.5 -1099.36,-109 -1625.96,-209.7 -534.43,-102.1 -1052.35,-237.3 -1551.69,-409.6 l -81.48,-114.1 -97.77,-342.2 65.18,-24.4 -122.22,-138.5 97.78,-505.2 c -150.2,0.1 -97.54,-103.8 52.7,-109.3 l 239.15,6.3 873.29,-133.3 c 0,0 -10.72,152.6 -3.76,377 9.82,316.7 305.66,955.9 997.96,915.5 799.58,-46.6 955.03,-614.3 974.82,-952.4 10.83,-184.8 2.75,-331.9 2.75,-331.9 z",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 36.34,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 9256.49,20837.8 4276.01,32.6 c 31.5,487 281.3,914.5 886.4,1245 572.2,312.5 134.9,532.5 0,690.9 -283.8,333.3 -1697.5,696.4 -2797.6,595.5 -911.4,-83.7 -1970.33,-468.3 -2364.81,-895.3 -227.19,-245.9 -214.76,-935.1 0,-1668.7 z",
    style: {
      fill: "none",
      strokeWidth: 36.34,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1,
      stroke: "rgb(0, 0, 0)"
    },
    id: "path58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 11955.1,20858.4 c 0,6.1 -176.7,663.8 -142.5,1107.4 35.5,460.8 207.6,677.6 207.6,677.6",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 36.34,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path60"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 11478.1,22089.4 c 161.7,6.1 310.2,55.6 307.3,134.7 -3,79.1 -136.7,105.8 -298.5,99.8 -161.8,-6.1 -310.3,-55.7 -307.3,-134.7 2.9,-79.1 136.7,-105.8 298.5,-99.8 z",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 36.34,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 13837.7,22135 c 161.7,6.1 310.2,55.7 307.3,134.8 -3,79.1 -136.7,105.8 -298.5,99.7 -161.8,-6.1 -310.3,-55.6 -307.3,-134.7 2.9,-79.1 136.7,-105.8 298.5,-99.8 z",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 36.34,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 11844.2,22643.4 241.2,743",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 36.34,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 17140.7,26983.8 c -802.6,142.7 -1668.6,152.2 -2736.3,-1 -1539.6,-176.8 -3320.8,-44.4 -5397.38,438.9 -183.47,-119.2 -321.72,-195.1 -516.12,-218.9 -895.49,-109.4 -2173.61,-280.1 -2682.99,-410.5 -194.4,-49.8 -449.47,-177.4 -449.47,-177.4 -232.55,-142.3 -259.27,-819 -261.42,-1187.1 -2.64,-453.7 55.24,-886.1 259.76,-1170.3 116.07,-86.5 240.22,-145.2 448,-184.7 743.88,-141.7 1785.82,-317.2 2678.73,-407.6 176.63,-23.2 343.2,-125 519.82,-219.8 -54.09,102.8 3982.77,688 5390.67,426.1 859.9,-160 1760.6,-194.2 2749.7,6.2 303.2,61.4 414.8,438.9 477.6,706.8 146.1,622.9 77.4,1198.6 -2,1702.9 -43,273.1 -245.9,655.1 -478.6,696.4 z",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 36.34,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2785.27,25001.9 c 10.03,156.2 10.03,705.9 0,862.1 -12.6,196.3 -48.38,504.6 81.67,743.7 38.64,240.7 26.21,609.7 -45.46,722.2 -121.93,191.5 -141.85,356.6 102.39,409.6 286.92,62.3 1227.86,180.6 1576.86,122.9 125.4,-20.7 310.16,-73.1 409.57,-307.2 57.57,-738.9 69.47,-2127.2 69.47,-2127.2 0,0 -11.9,-1378.3 -69.47,-2117.3 -99.41,-234 -284.17,-286.4 -409.57,-307.1 -349,-57.7 -1289.94,60.5 -1576.86,122.8 -244.24,53 -224.32,218.1 -102.39,409.6 71.67,112.6 84.1,481.5 45.46,722.2 -130.05,239.1 -94.27,547.5 -81.67,743.7 z",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 36.34,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 3625.29,25431.6 c -58.07,-1049.6 -110.32,-2066 43.39,-2409.6",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 36.34,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path72"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 3625.99,25437.6 c -58.07,1049.6 -120.61,2055.7 33.11,2399.3",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 36.34,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path74"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 3789.21,24583.4 c -11.07,163.8 -1.06,847.7 -1.06,847.7 0,0 -10.01,690.6 1.06,854.4 3.29,48.8 11.71,90.7 61.84,132.9 64.58,43 133.94,81.3 210.73,112.2 71.39,44.1 113.42,-39.7 121.4,-89.3 29.33,-182.5 52.65,-668.4 54.95,-1010.5 0,0 -25.62,-820.7 -54.95,-1003.2 -7.98,-49.6 -50.01,-133.4 -121.4,-89.3 -76.79,30.9 -146.15,69.2 -210.73,112.2 -50.13,42.2 -58.55,84.2 -61.84,132.9 z",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 36.34,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path76"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 3769.53,24152.4 c -2.19,69.2 49.83,88.4 113.83,59.6 67.06,-30.2 194.13,-110.1 213.57,-208.3 12.1,-61.2 66.94,-165.9 122.31,-229.3 60.1,-68.8 259.7,-171.8 153.77,-323.8 -147.38,-211.6 -507.01,-125.4 -567.59,100.1 -39.85,148.3 -32.43,492.2 -35.89,601.7 z",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 36.34,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path78"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 3786.43,26708.4 c -2.19,-69.2 49.83,-88.4 113.83,-59.6 67.06,30.2 194.13,110.1 213.57,208.3 12.1,61.2 66.94,165.9 122.31,229.3 60.1,68.8 259.7,171.8 153.77,323.8 -147.38,211.5 -507.01,125.4 -567.58,-100.1 -39.86,-148.3 -32.44,-492.2 -35.9,-601.7 z",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 36.34,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 17822.7,25403.1 -1.7,56.1 c 23.7,1052.6 121.4,1933.9 818.1,2089.2 163.1,48.7 143.8,192.7 188.5,230 93.1,77.8 410.1,47.1 538.2,-27.3 128.2,-74.5 246,-132.1 230.7,-419.4 l -14,-1901.4 14,-1901.4 c 15.3,-287.3 -102.5,-344.9 -230.7,-419.4 -128.1,-74.4 -445.1,-105.1 -538.2,-27.3 -44.7,37.3 -25.4,181.3 -188.5,230 -696.7,155.3 -792.7,1038.3 -816.4,2090.9 z",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 36.34,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 18514.5,24292.7 c 48.6,60.5 63.5,56.8 71.2,3.7 0.6,-268.5 8.7,-553.5 27.4,-831 0.8,-70.6 -61.1,-55.7 -106.5,-51.7 -130.2,11.3 -359.1,278.1 -379.5,373 -9.3,43.1 -37,85.4 22,140.6 z",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 36.34,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 18510.2,26557.6 c 48.6,-60.5 63.6,-56.8 71.2,-3.7 0.6,268.5 8.7,553.5 27.4,831.1 0.8,70.5 -61.1,55.6 -106.4,51.7 -130.3,-11.4 -359.2,-278.2 -379.6,-373.1 -9.3,-43.1 -36.9,-85.4 22,-140.5 z",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 36.34,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path86"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 18712.7,25431.4 c 0,0 17.1,-874.2 -80.5,-939.2 -97.5,-65.1 13.7,-104.1 13.7,-104.1 l 39,-1059.9",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 36.34,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 18710.6,25435 c 0,0 17,874.3 -80.5,939.3 -97.5,65 13.6,104 13.6,104 l 39,1060",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 36.34,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path90"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCar);
export default __webpack_public_path__ + "static/media/car.ca836b50a07a4d0fafde2d1ea5d5f77a.svg";
export { ForwardRef as ReactComponent };